class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.swiper = new window.Swiper(this.querySelector('.swiper'), {
      loop: true,
      slidesPerView: 1,
      init: false
    });

    this.swiper.on('slideChange', () => {
      this.updateThumbnailHighlight(this.swiper.realIndex);
    });

    this.swiper.on('init', () => {
      this.updateThumbnailHighlight(this.swiper.realIndex);
    });

    this.swiper.init();

    this.modal = this.querySelector('.zoom-modal');
    this.gallery = this.modal.querySelector('[data-gallery]');
    this.closeBtn = this.modal.querySelector('[data-close]');

    this.setupThumbnails();
    this.setupZoomTriggers();
    this.setupZoomClose();
  }

  setupThumbnails() {
    this.querySelectorAll('[data-thumb-index]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.thumbIndex, 10);
        this.swiper.slideToLoop(index);
      });
    });
  }

  setupZoomTriggers() {
    this.querySelectorAll('[data-zoom-index]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const index = parseInt(trigger.dataset.zoomIndex, 10);
        this.openZoom(index);
      });
    });
  }

  setupZoomClose() {
    this.closeBtn?.addEventListener('click', () => this.closeZoom());
    this.modal.addEventListener('click', () => this.closeZoom());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeZoom();
    });
  }

  openZoom(index) {
    this.modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      const target = this.gallery.querySelector(`[data-index="${index}"]`);
      target?.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  }

  closeZoom() {
    this.modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  updateThumbnailHighlight(index) {
    this.querySelectorAll('[data-thumb-index]').forEach((thumb) => {
      thumb.classList.toggle('is-active', parseInt(thumb.dataset.thumbIndex) === index);
    });
  }
}

customElements.define('product-media', ProductMedia);